<template>
  <div>
    <custom-actions :panel="false">
      <template #header>
        <el-button type="primary" @click="showSetting">修改类型配置</el-button>
      </template>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-empty v-if="!['1', '2', '3'].includes(type)" description="当前配置不显示温度"></el-empty>
      <el-table v-if="['1', '2', '3'].includes(type)" size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip label="类型" prop="type">
          <template v-slot="{ row }">{{ temperature.get(row.type) }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="小时" prop="hour"></el-table-column>
        <el-table-column show-overflow-tooltip label="温度" prop="temperature"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="{ row }">
            <el-button type="text" @click="showTemperature(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="配置修改" :close-on-click-modal="false" class="global-dialog global-dialog-w400"
      :visible.sync="dialogVisible1">
      <el-form class="setting-form">
        <el-form-item label="当前配置">
          <el-select v-model="currentType" placeholder="请选择">
            <el-option v-for="([key, value], index) of temperature" :value="key" :label="value"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveSetting">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="温度配置" :close-on-click-modal="false" class="global-dialog global-dialog-w400"
      :visible.sync="dialogVisible2">
      <el-form ref="temperatureForm" class="setting-form" :rules="rules" :model="temperatureForm">
        <el-form-item label="当前温度" prop="temperature">
          <el-input v-model="temperatureForm.temperature" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="saveTemperature">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { temperature } from '@/utils/dict'
function validTemperature (rule, value, callback) {
  if (!/^(-?\d{1,2}(\.\d)?|100(\.0)?)$/.test(value)) {
    return callback(new Error('请输入-100至100的数字，可保留一位小数'))
  } else {
    callback()
  }
}
export default {
  name: 'TimeConfig',
  data () {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      type: '',
      currentType: '',
      temperature: temperature,
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
      },
      temperatureForm: {
        hour: '',
        type: '',
        temperature: ''
      },
      rules: {
        temperature: [
          { required: true, message: '请输入温度', trigger: ['blur', 'change'] },
          { validator: validTemperature, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  async created () {
    const type = await this.loadYgTemperatureSwitch()
    this.type = type
    this.currentType = type
    if (['1', '2', '3'].includes(type)) {
      this.loadData(type)
    }
  },
  methods: {
    loadYgTemperatureSwitch () {
      return this.$axios.get(this.$apis.timeconfig.selectYgTemperatureSwitch)
    },
    loadData (type) {
      this.loading = true
      this.$axios.get(this.$apis.timeconfig.selectYgTemperatureByList, {
        params: {
          type
        }
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    showSetting () {
      this.currentType = this.type
      this.dialogVisible1 = true
    },
    showTemperature (row) {
      this.temperatureForm = JSON.parse(JSON.stringify(row))
      this.dialogVisible2 = true
    },
    saveTemperature () {
      this.$refs.temperatureForm.validate().then(() => {
        this.$axios.post(this.$apis.timeconfig.updateYgTemperature, this.temperatureForm).then(() => {
          this.dialogVisible2 = false
          this.loadData(this.type)
        })
      })
    },
    saveSetting () {
      this.$axios.post(this.$apis.timeconfig.updateYgTemperatureSwitch, {
        type: this.currentType
      }).then(() => {
        this.dialogVisible1 = false
        this.type = this.currentType
        this.loadData(this.type)
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.setting-form {
  padding: 20px;
}
</style>
